import { useMemo } from 'react';
import { localeStore } from 'src/mobx/localesStore';
import Picker from 'src/view/components/Controls/Pickers/Picker/Picker';
import { IPickerOption } from 'src/view/components/Controls/Pickers/Picker/types';
import { messageCampaignStore } from '~/view/screens/MarketingScreen/screens/MessageCampaign/CampaignEditScreen/store/messageCampaignStore';

const CampaignDeliveryMethod: React.FC<{}> = (): JSX.Element => {
  const options = useMemo((): IPickerOption[] => {
    return [messageCampaignStore.deliveryMethod];
  }, []);

  return (
    <div className="d-flex flex-row align-items-center mr-4">
      <p className="family-medium text-size-18 color-dark mr-2">{localeStore.t('delivery_method')}</p>
      <Picker
        options={options}
        selectedOptions={[messageCampaignStore.deliveryMethod]}
        onSelect={(el) => messageCampaignStore.changeDeliveryMethod(el[0])}
        hideResetIcon
        noReset
      />
    </div>
  );
};

export default CampaignDeliveryMethod;
